import { CLEAR_PAGE } from '../base/types';
import { FETCH_PROMOS, CREATE_PROMO, UPDATE_PROMO, DELETE_PROMO } from './actionsTypes';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: [],
};

const promosReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_PROMOS}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_PROMOS}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoading: false,
        isLoaded: true,
      };
    case `${FETCH_PROMOS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case `${CREATE_PROMO}_FULFILLED`:
      return {
        ...state,
        data: [...state.data, payload],
      };
    case `${UPDATE_PROMO}_FULFILLED`:
      return {
        ...state,
        data: state.data.map((i) => {
          if (Number(i.id) === Number(payload.id)) {
            return payload;
          }
          return i;
        }),
      };
    case `${DELETE_PROMO}_FULFILLED`:
      return {
        ...state,
        data: state.data.filter((i) => Number(i.id) !== Number(payload?.id)),
      };

    case CLEAR_PAGE:
      return payload === 'promos' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default promosReducer;
